import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useCurrentAccount } from "../../../../Contexts/UserContext";
import {
  useAccount,
  useEmail,
  useEmailConversation,
} from "../../../../Hooks/EntityHooks";
import Modal from "../../../Modal/Modal";
import Button from "../../../Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPaperclip,
  faPaperPlane,
  faRobot,
  faSend,
} from "@fortawesome/pro-light-svg-icons";
import { FormattedMessage, useIntl } from "react-intl";
import { getFilesAsync } from "../../../Files/Files";
import {
  getEntity,
  useSpaceMultiplePost,
  useSpacePost,
  useSpacePostQuery,
  useSpaceQuery,
} from "../../../../Helpers/IOClient";
import {
  spaceEmailSchema,
  spaceSignatureAggregationSchema,
} from "../../../../config/schema";
import { useConnectionId } from "../../../../Containers/RealTime/RealTime";
import {
  createFormData,
  findVal,
  handleError,
  handleErrorWithIntl,
} from "../../../../Helpers/MiscHelper";
import { useToast } from "../../../Toast/ToastProvider";
import { EmailPreviewFormContext } from "./MessageSender";
import ClipboardProvider from "../../../ClipbordProvider/ClipboardProvider";
import {
  ContactDropdown,
  EmailSignaturesTypesDropdown,
} from "../../../../Containers/AdvancedMultiInputs";
import Input from "../../../Input/Input";
import DocTyper from "../../../DocTyper/DocTyper";
import classNames from "classnames";
import MessageSenderFiles from "./MessageSenderFiles";
import { UpploadReact } from "../../../FileUploader/Upploader";
import FormInput from "../../../Forms/FormInput/FormInput";
import LoadableButton from "../../../Button/LoadableButton";
import LoaderSpinner from "../../../Loader/LoaderSpinner/LoaderSpinner";
import KeyedDropdown from "../../../Dropdown/KeyedDropdown";
import MainLoader from "../../../Loader/MainLoader";
import { useEntitySummarySidebar } from "../../EntitySummariesHelper";
import { moduleTypes } from "../../../../Helpers/ModulesHelper";

const calculateSize = (fd) => {
  let size = 0;

  for (const e of fd.entries()) {
    size += new Blob([e[0]]).size;
    size += new Blob([e[1]]).size;
  }
  return size;
};

const EmailSenderItem = ({ title, children }) => {
  return (
    <div
      className="d-flex align-items-center of-hidden mb-2"
      style={{ maxHeight: 95 }}
    >
      <div className="text-black fs-14" style={{ width: 100 }}>
        {title}
      </div>
      <div className="d-flex flex-1 h-100 of-hidden" style={{ maxHeight: 95 }}>
        {children}
      </div>
    </div>
  );
};

const ItemTypeComponent = ({ item }) => {
  return (
    <div style={{ textTransform: "capitalize" }}>{item?.toLowerCase()}</div>
  );
};

const AIOriginOptions = ["PRIMAVERA", "SIGER", "GENERICO"];

const AiOriginDropdown = ({ value, onChange }) => {
  return (
    <KeyedDropdown
      ListComponent={ItemTypeComponent}
      valueComponent={ItemTypeComponent}
      options={AIOriginOptions}
      closeOnSelect
      value={value}
      onChange={onChange}
    />
  );
};

const AiEditorContent = React.forwardRef((props, ref) => {
  const {
    disabled,
    entityId,
    schema,
    messages,
    onChangeReplyMessageId,
    addMessage,
    updateMessageCounter,
    formMinimized,
    onFocus,
    handleClosure,
    setFormMinimized,
    roomType,
  } = props;
  const [completeDisabled, setCompleteDisabled] = useState(false);
  const intl = useIntl();
  const [indexedKey, setIndexedKey] = useState(1);
  const [files, setFiles] = useState([]);

  const handleDrop = async (e) => {
    e.preventDefault();
    const files = e.dataTransfer
      ? await getFilesAsync(e.dataTransfer)
      : e.currentTarget.files;
    setFiles((f) => [...f, ...files]);
  };

  const emailConversation = useEmailConversation(entityId);
  const user = useCurrentAccount();
  const {
    LastEmail,
    Status,
    Id: ConversationId,
    Client,
    InboundEmail,
    Manager,
    Tickets,
  } = emailConversation || {};

  const managerAccount = useAccount(Manager);

  const { FromContact, ToContacts, CcContacts, Subject, Account } =
    useEmail(LastEmail) || {};

  // console.log(FromContact, ToContacts, CcContacts);

  const [textKey, setTextKey] = useState(1);

  const [text, setText] = useState("");

  const [signature, setSignature] = useState(null);

  const preferenceBody = useMemo(() => {
    return { Key: `recent-signature-${user.Id}-${ConversationId}` };
  }, [ConversationId, user.Id]);

  const [preferenceSignature, setPreferenceSignature] = useState(null);

  useSpacePostQuery(`Preference`, preferenceBody, null, {
    cache: false,
    onSuccess: ({ data }) => {
      if (data !== "NO_ITEMS" && data !== "" && data !== null) {
        const resolvedData = JSON.parse(data);
        setPreferenceSignature(resolvedData);
      }
    },
    onError: ({ error }) => {
      // console.log(error);
    },
  });

  const { loading: loadingInitialBody } = useSpaceQuery(
    `EmailConversation/${ConversationId}/Initial`,
    null,
    {
      cache: false,
      onSuccess: ({ data }) => {
        if (data.Text) {
          setText(data.Text);
          setInitialId(data.Id);
          if (data.Department?.Name) {
            setAiOrigin(
              data.Department?.Name.toLowerCase().includes("primavera")
                ? "PRIMAVERA"
                : data.Department?.Name.toLowerCase().includes("aurora")
                  ? "SIGER"
                  : "GENERICO",
            );
          }
          setIndexedKey(2);
        }
      },
      onError: ({ error }) => {
        // console.log(error);
      },
    },
  );

  const preferencePost = useSpaceMultiplePost();

  const preferenceSignatureQueryUrl = useMemo(() => {
    const { data } = preferenceSignature || {};
    if (data) {
      return `Query/EmailSignatures?id=${data}`;
    } else return null;
  }, [preferenceSignature]);

  useSpaceQuery(preferenceSignatureQueryUrl, spaceSignatureAggregationSchema, {
    onSuccess: ({ data }) => {
      if (data !== null && data !== "NO_ITEMS" && data !== "")
        setSignature(preferenceSignature);
    },
  });

  const [resovledFirstEmail, setResovledFirstEmail] = useState(() => {
    if (Account === "00000000-0000-0000-0000-000000000001") {
      const firstEmail = Array.isArray(messages) && messages[0]?.Email;
      if (!firstEmail) return null;
      const resolvedFirstEmail = getEntity(spaceEmailSchema, firstEmail);
      const newFirstEmail = { ...resolvedFirstEmail };
      newFirstEmail.ToContacts = [resolvedFirstEmail.FromContact];
      return newFirstEmail;
    }
    return null;
  });

  const [to, setTo] = useState(() => {
    if (
      Account === "00000000-0000-0000-0000-000000000001" &&
      resovledFirstEmail
    ) {
      return resovledFirstEmail.ToContacts;
    }
    if (Account && ToContacts && ToContacts.length !== 0) return ToContacts;
    else if (FromContact) return [FromContact];
    else return [];
  });

  const [receiveNotfi, setReceiveNotfi] = useState(false);
  const [cc, setCc] = useState(() => {
    if (
      Account === "00000000-0000-0000-0000-000000000001" &&
      resovledFirstEmail
    ) {
      return resovledFirstEmail.CcContacts || [];
    } else return CcContacts || [];
  });
  const [bcc, setBcc] = useState([]);
  const [subject, setSubject] = useState(() => {
    if (Subject && !Subject.toLowerCase().startsWith("re:"))
      return `RE: ${Subject}`;
    return Subject || "";
  });

  const alredyRan = useRef(false);
  useEffect(() => {
    if (!alredyRan.current && LastEmail !== undefined) {
      if (
        Account === "00000000-0000-0000-0000-000000000001" &&
        resovledFirstEmail
      ) {
        setTo(resovledFirstEmail.ToContacts);
      }

      if (Account && ToContacts && ToContacts.length !== 0) setTo(ToContacts);
      else if (FromContact) setTo([FromContact]);

      if (
        Account === "00000000-0000-0000-0000-000000000001" &&
        resovledFirstEmail
      ) {
        setCc(resovledFirstEmail.CcContacts || []);
      } else setCc(CcContacts || []);

      if (Subject && !Subject.toLowerCase().startsWith("re:"))
        setSubject(`RE: ${Subject}`);
      else setSubject(Subject || "");

      alredyRan.current = true;
    }
  }, [
    Account,
    CcContacts,
    FromContact,
    LastEmail,
    Subject,
    ToContacts,
    resovledFirstEmail,
  ]);
  const [aiOrigin, setAiOrigin] = useState("GENERICO");
  const conId = useConnectionId();
  const openForm = useEntitySummarySidebar();
  const [initialId, setInitialId] = useState(null);
  const [postAIQuestion, { loading: loadingAiQuestion }] = useSpacePost(
    `EmailConversation/${ConversationId}/QuestionAi`,
    null,
    {
      onSuccess: ({ data }) => {
        if (data.Success) {
          if (data.Text.includes("credit balance is too low")) {
            handleError(createToast, {
              Message: "Atingiu o limite de perguntas ao AI.",
            });
            setCompleteDisabled(true);
          } else if (data.Text.includes(`"type":"error"`)) {
            handleError(createToast, {});
          } else {
            setText(data.Text);
            setIndexedKey((oldT) => oldT + 1);
          }
        } else {
          handleError(createToast, {});
        }
      },
      onError: ({ error }) => {
        handleError(createToast, error);
      },
    },
  );

  const [postSaveAIQuestion, { loading: loadingSaveAiQuestion }] = useSpacePost(
    `EmailConversation/${ConversationId}/SaveAi`,
    null,
    {
      onSuccess: ({ data }) => {
        handleSubmit();
      },
      onError: ({ error }) => {
        handleError(createToast, error);
      },
    },
  );

  const handleAskAiQuestion = useCallback(() => {
    postAIQuestion({
      Id: initialId,
      Origin: aiOrigin,
      TicketIds: Tickets,
      Text: Subject + " " + text,
    });
  }, [Subject, Tickets, aiOrigin, initialId, postAIQuestion, text]);

  const handleSaveAiAnswer = useCallback(() => {
    postSaveAIQuestion({
      Id: initialId,
      Origin: aiOrigin,
      TicketIds: Tickets,
      Text: Subject + " " + text,
    });
  }, [Subject, Tickets, aiOrigin, initialId, postSaveAIQuestion, text]);

  const [post, { loading }] = useSpacePost(
    `EmailConversation/${entityId}/Reply`,
    null,
    {
      onSuccess: () => {
        createToast({
          pos: "tm",
          type: "success",
          title: intl.formatMessage({ id: "TEST_EMAIL_SEND_SUCCESS" }),
        });
        openForm({
          type: moduleTypes.interventions,
          props: {
            edit: true,
            ticketId: Tickets[0],
            defaultForm: {
              Description: Subject + " " + text,
            },
          },
        });

        handleClosure();
      },
      onError: ({ error }) => {
        let msgKey = findVal(error, "Message");
        if (msgKey === "API_EMAIL_SUBJECT_INVALID") {
          handleErrorWithIntl(createToast, "API_EMAIL_SUBJECT_INVALID");
        } else handleError(createToast, error);
      },
      headers: {
        ConnectionID: conId,
      },
    },
  );
  const createToast = useToast();
  const handleSubmit = useCallback(() => {
    if (Status && Status === 1) {
      createToast({
        pos: "tm",
        type: "danger",
        description: <FormattedMessage id={"CANT_REPLY_CLOSED_CONVERSATION"} />,
        title: `Erro`,
      });
      return;
    }

    if (text === "") return;
    let resolvedSignature = undefined;
    if (signature) {
      const { type, data } = signature;
      const connectedSignature = getEntity(
        spaceSignatureAggregationSchema,
        data,
      );
      const { Company, Department, Team, SignatureId } =
        connectedSignature || {};
      let OrganizationId = undefined;
      switch (type) {
        case "Company":
          OrganizationId = Company;
          break;
        case "Department":
          OrganizationId = Department;
          break;
        case "Team":
          OrganizationId = Team;
          break;
        default:
          break;
      }

      resolvedSignature = {
        OrganizationId,
        Id: SignatureId,
      };
    }

    const data = createFormData(
      {
        Text: text,
        Subject: subject,
        To: JSON.stringify(to),
        Cc: JSON.stringify(cc),
        Bcc: JSON.stringify(bcc),
        Signature: resolvedSignature
          ? JSON.stringify(resolvedSignature)
          : undefined,
      },
      files,
    );

    const globalEmailSize = calculateSize(data);
    if (globalEmailSize > 5000000) {
      createToast({
        pos: "tm",
        type: "danger",
        description: <FormattedMessage id={"EMAIL_SIZE_TOO_BIG"} />,
        title: `Erro`,
      });
      return;
    } else post(data);
  }, [Status, bcc, cc, createToast, files, post, signature, subject, text, to]);

  const handleAskAi = useCallback(() => {}, []);

  const HandleExtraUploads = (f) => {
    setFiles((e) => [...e, f]);
  };

  const handleToChange = (v) => {
    setTo(v);
  };

  const handleCcChange = (v) => {
    setCc(v);
  };

  const handlebccChange = (v) => {
    setBcc(v);
  };

  const handleAIOriginChange = (v) => {
    setAiOrigin(v);
  };

  const handleReceiveNotif = (v) => {
    setReceiveNotfi(v);
  };

  const handleApplyToUserPick = (e) => {
    const { value } = e.target;
    setSignature(value);
  };

  const [showCC, setShowCC] = useState(() => {
    if (cc.length > 0) return true;
    else return false;
  });

  useEffect(() => {
    if (cc.length > 0 && !showCC) setShowCC(true);
  }, [cc, showCC]);

  const [showBCC, setShowBCC] = useState(false);
  const FormRef = useContext(EmailPreviewFormContext);

  useEffect(() => {
    const formdata = {
      text,
      subject,
      to,
      cc,
      bcc,
      signature,
    };
    FormRef.current = formdata;
  }, [FormRef, bcc, cc, signature, subject, text, to]);

  return (
    <ClipboardProvider>
      <div className="d-flex flex-column py-3 h-100 w-100 of-hidden position-relative">
        {loadingInitialBody ||
        loadingAiQuestion ||
        loading ||
        loadingSaveAiQuestion ? (
          <div
            style={{
              zIndex: 2,
              opacity: "50%",
            }}
            className={classNames(
              "position-absolute bg-white h-100 w-100 top-0 left-0 opacity-50",
            )}
          >
            {/* <LoaderSpinner
              size="sm"
              center
              className="text-primary w-100 d-flex align-items-center justify-content-around"
            /> */}
            <MainLoader />
          </div>
        ) : (
          <></>
        )}
        {!formMinimized && (
          <div>
            <div className="d-flex w-full mb-3 justify-content-end">
              <LoadableButton
                isLoading={loading}
                type="button"
                disabled={completeDisabled || text === "" || to.length === 0}
                onClick={handleSaveAiAnswer}
              >
                Enviar resposta
                {/* <FormattedMessage id="SEND" /> */}
                <FontAwesomeIcon className="ml-2" icon={faPaperPlane} />
              </LoadableButton>
            </div>
            <EmailSenderItem title={intl.formatMessage({ id: "EMAIL_TO" })}>
              <div className="align-items-center  d-flex flex-1 of-hidden w-100">
                <div className="flex-1 h-100 of-hidden w-100">
                  <ContactDropdown
                    grid
                    multiple
                    labelClassName="h-100"
                    containerClassName="h-100"
                    className="h-100"
                    value={to}
                    onChange={handleToChange}
                    hasEmail
                    IndirectClient={Client}
                    EmailConversationId={ConversationId}
                  />
                </div>
                {!showCC && (
                  <Button
                    vType="link-primary"
                    className="ml-2"
                    onClick={() => setShowCC(true)}
                  >
                    CC
                  </Button>
                )}
                {!showBCC && (
                  <Button
                    vType="link-primary"
                    className="ml-2"
                    onClick={() => setShowBCC(true)}
                  >
                    BCC
                  </Button>
                )}
              </div>
            </EmailSenderItem>
            {showCC && (
              <EmailSenderItem title={"Cc"}>
                <div className="align-items-center  d-flex flex-1 of-hidden w-100">
                  <div className="flex-1 h-100 of-hidden w-100">
                    <ContactDropdown
                      grid
                      multiple
                      labelClassName="h-100"
                      containerClassName="h-100"
                      className="h-100"
                      value={cc}
                      onChange={handleCcChange}
                      hasEmail
                      IndirectClient={Client}
                      EmailConversationId={ConversationId}
                    />
                  </div>
                </div>
              </EmailSenderItem>
            )}

            {showBCC && (
              <EmailSenderItem title={"Bcc"}>
                <div className="align-items-center  d-flex flex-1 of-hidden w-100">
                  <div className="flex-1 h-100 of-hidden w-100">
                    <ContactDropdown
                      grid
                      labelClassName="h-100"
                      containerClassName="h-100"
                      className="h-100"
                      multiple
                      value={bcc}
                      onChange={handlebccChange}
                      hasEmail
                      IndirectClient={Client}
                      EmailConversationId={ConversationId}
                    />
                  </div>
                </div>
              </EmailSenderItem>
            )}

            <EmailSenderItem title={intl.formatMessage({ id: "SUBJECT" })}>
              <Input
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </EmailSenderItem>
          </div>
        )}
        <React.Fragment key={indexedKey}>
          <DocTyper
            noToolbar={formMinimized}
            key={textKey}
            DisabledmaximizeButton={true}
            ref={ref}
            onFocus={onFocus}
            className={classNames("mt-3 flex-1")}
            value={text}
            onChange={setText}
            onDrop={handleDrop}
          />
        </React.Fragment>
        {files && files.length > 0 && (
          <div
            style={{ maxHeight: 96 }}
            className="mb-1 mt-2 flex-0-0-auto of-y-auto of-x-hidden"
          >
            <MessageSenderFiles files={files} setFiles={setFiles} />
          </div>
        )}
        <div className="d-flex align-items-center justify-content-between mt-2">
          <div className="d-flex align-items-center flex-1">
            <div className="d-flex align-items-center">
              <label className="ar-entity-summary-message-rounded-button ar-entity-summary-message-send-button">
                <FontAwesomeIcon icon={faPaperclip} />

                <input
                  className="ar-fileUploader__inputFile"
                  // accept={accept && accept.join(",")}
                  type="file"
                  multiple
                  onChange={handleDrop}
                />
              </label>
              <div className="">
                <UpploadReact onFileDone={HandleExtraUploads} Chat={true} />
              </div>
            </div>
            <span className="fs-14 mr-2">
              <FormattedMessage id="SIGNATURE" />:
            </span>
            <FormInput
              value={signature}
              onChange={handleApplyToUserPick}
              className="mr-2 flex-1"
              inputType={EmailSignaturesTypesDropdown}
              name="ReplySignatureModel"
              type={2}
            />
          </div>
          <div className="mr-2" style={{ minWidth: 150 }}>
            {initialId && (
              <AiOriginDropdown
                value={aiOrigin}
                onChange={handleAIOriginChange}
              />
            )}
          </div>
          <LoadableButton
            isLoading={false}
            type="button"
            disabled={completeDisabled || text === "" || to.length === 0}
            className="float-right"
            onClick={handleAskAiQuestion}
          >
            {/* <FormattedMessage id="ASK_AI" /> */}
            Perguntar ao AI
            <FontAwesomeIcon className="ml-2" icon={faRobot} />
          </LoadableButton>
        </div>
      </div>
    </ClipboardProvider>
  );
});

const EnabledUserIds = [
  "134dc022-31a3-40e1-a513-8cbd75c7faa9", //Cristina Silva
  "ea97e28b-fb84-4564-8a78-2a98d1905561", //Celia Gomes
  "44d7ba9d-e35e-4d25-ab5e-500adb615104", //Ana Margarida Pereira
  "dc28ee22-5088-43f7-83c1-5552b7d99868", //Assis Carlos
  "903b311e-06fa-4217-9c43-7e9a2c204bf5", //Jose Borges
  "6e3b9234-4155-465b-b68c-cc9a10a660b5", //Ruben Pires
];

const EmailAiComponent = ({ emailConversationId, messages }) => {
  const { Tickets } = useEmailConversation(emailConversationId);
  const { Id, IsDeveloper } = useCurrentAccount();
  const [open, setOpen] = useState(false);

  const handleClosure = useCallback(() => {
    setOpen(false);
  }, []);

  if (!EnabledUserIds.includes(Id)) {
    return <></>;
  }

  if (
    !Array.isArray(Tickets) ||
    (Array.isArray(Tickets) && Tickets.length === 0)
  )
    return <></>;

  return (
    <>
      <Modal
        className="h-100 d-flex align-items-center justify-content-center"
        isOpen={open}
        enableCloseButton
        onClose={handleClosure}
      >
        <div
          style={{ width: "75vw", height: "90vh" }}
          className="bg-white rounded px-4 py-2"
        >
          <AiEditorContent
            handleClosure={handleClosure}
            messages={messages}
            entityId={emailConversationId}
          />
        </div>
      </Modal>
      <Button
        vType="primary-ghost"
        type="button"
        size="sm"
        className="mr-3 d-flex w-fit align-items-center"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <span className="mr-2">AI</span>
        <FontAwesomeIcon icon={faRobot} />
      </Button>
    </>
  );
};

export default EmailAiComponent;
